module.exports = __webpack_public_path__ + "img/college2.5fee5136.png";